import React from 'react';

import { SharePanelFormSection } from './section';

const SharePanelFormEmbedSectionLink = () => {
  return (
    <SharePanelFormSection type='embed' title='Embed' subTitle='Display this Journey on your website or elsewhere' />
  );
};

export default SharePanelFormEmbedSectionLink;
